var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlignRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4 4.7998C17.7314 4.7998 18 5.06843 18 5.39981V18.5998C18 18.9312 17.7314 19.1998 17.4 19.1998C17.0686 19.1998 16.8 18.9312 16.8 18.5998V5.3998C16.8 5.06843 17.0686 4.7998 17.4 4.7998Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.72 12.9598C6.32235 12.9598 6 12.6375 6 12.2398C6 11.8422 6.32235 11.5198 6.72 11.5198H13.0924L11.021 9.63881C10.7343 9.36319 10.7254 8.9074 11.001 8.62077C11.2766 8.33413 11.7324 8.32519 12.019 8.60081L15.379 11.7208C15.5202 11.8566 15.6 12.044 15.6 12.2398C15.6 12.4357 15.5202 12.6231 15.379 12.7588L12.019 15.8788C11.7324 16.1544 11.2766 16.1455 11.001 15.8588C10.7254 15.5722 10.7343 15.1164 11.021 14.8408L13.0924 12.9598H6.72Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlignRight);
export default __webpack_public_path__ + "static/media/align-right.ad9d2ca4fd4da7c2edbaa91e52bab146.svg";
export { ForwardRef as ReactComponent };